import Echo from 'laravel-echo';

EchoService.$inject = ['$window', '_'];

/* @ngInject */
function EchoService($window, _) {

    /**
     * Server is a decorator of Echo, that refreshes the whole instance when reconnecting
     * @method Server
     */
    var Server = function () {
    };

    Server.config = {
        broadcaster: 'socket.io',
        host: $window.location.hostname + ':6001'
    };

    Server.prototype = _.create(Echo.prototype, {
        'constructor': Server
    });

    Server.prototype.reconnect = function () {
        Echo.call(this, Server.config);
    };

    /**
     * Update token using the Laravel.csrfToken variable
     * @method updateCsrfToken
     * @chainable
     */
    Server.prototype.updateCsrfToken = function (token) {
        this.connector.options.auth.headers['X-CSRF-TOKEN'] = token;
        return this;
    };

    /**
     * @property defaultChannel
     * @type {String}
     */
    Server.prototype.defaultChannel = '\\Illuminate\\Notifications\\Events\\BroadcastNotificationCreated';

    return new Server();
}

export default EchoService;